import React, { useState, useRef, useEffect  } from "react";
import Sparkle from 'react-sparkle'
import { Link, useNavigate } from 'react-router-dom';
import { useConfirmarSeleccion } from "../../../../../Hooks/Player";

import { 
  Container,
  Gashapon,
  Manilla,
  Engranaje,
  Notify,
  GashaBall,
  PrizeContainer,
  GashaBallOpen,
  PokeImg,ButtonSelect
 } from './styles'

import {CapsulaChoosen} from '../Capsulas';

// SONIDOS
import useSound from 'use-sound';
import ITEMRECIEVEDMP3 from '../../../../../Assets/itemfound.mp3';
import POPMP3 from '../../../../../Assets/pop.mp3';

const POKEIMAGENESURL = import.meta.env.VITE_POKEIMAGENES_URL;

export const Maquina = ({children, coin_id, gacha_id, pokemonSelected, imagenesCache, stopSong, keyCache = null}) => {
  // Mapea idObjeto -> cantidad de tiradas. ⚠️ Hardcodeado a ids 33/34/35 de la DB.
  // Si los ids cambian, esto se rompe silenciosamente (slice(0, undefined) = todos los pokemones del pool).
  // Fix durable pendiente: hacer que el backend devuelva la cantidad en el response de canjearGachapon
  // y leerla directamente desde data.cantidadCapturas en vez de mapear por id.
  const coinTransform = {
    33: 1,  // Ficha Pokeball -> 1 resultado
    34: 2,  // Ficha Superball -> 2 resultados
    35: 3   // Ficha Ultraball -> 3 resultados
  }
  const POKEEJEMPLOSCOIN = pokemonSelected.slice(0, coinTransform[coin_id]);

  const [pokeChoose, setChoose] = useState(POKEEJEMPLOSCOIN.length == 1 ? POKEEJEMPLOSCOIN[0] : null)

  useEffect(() => {
    setChoose(POKEEJEMPLOSCOIN.length == 1 ? POKEEJEMPLOSCOIN[0] : null)
  }, [pokemonSelected])
  

  const [angle, setAngle] = useState(0); // Ángulo actual
  const [fullTurns, setFullTurns] = useState(0); // Conteo de vueltas completas
  const previousAngle = useRef(0); // Ángulo en el último movimiento
  const hasTriggered = useRef(false); // Bandera para evitar múltiples disparos
  const accumulatedAngle = useRef(0); // Acumulador de ángulo
  const centerRef = useRef({ x: 0, y: 0 }); // Centro de la manilla
  const [playbackRate, setPlaybackRate] = useState(0.5);
  const [popFX] = useSound(POPMP3, {
    playbackRate,
    volume: 0.1,
    // `interrupt` ensures that if the sound starts again before it's
    // ended, it will truncate it. Otherwise, the sound can overlap.
    interrupt: true,
  });

  // Función para manejar la vibración mientras se gira la manilla
  const startVibration = () => {
    popFX();
    setPlaybackRate(playbackRate + 0.01);
    if (navigator.vibrate) {
      navigator.vibrate(100); // Vibra por 100ms
    }
  };

  const stopVibration = () => {
    if (navigator.vibrate) {
      navigator.vibrate(0); // Detiene la vibración
    }
  };

  const handlePointerDown = (e) => {
    const rect = e.target.getBoundingClientRect();
    centerRef.current = {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
    };
    e.target.setPointerCapture(e.pointerId);
    accumulatedAngle.current = 0; // Reiniciar el acumulador al iniciar el giro
  };

  const handlePointerMove = (e) => {
    if (centerRef.current.x === 0 && centerRef.current.y === 0) return;

    const { clientX, clientY } = e;

    // Calcular el ángulo actual basado en el puntero y el centro de la imagen
    const dx = clientX - centerRef.current.x;
    const dy = clientY - centerRef.current.y;
    const currentAngle = Math.atan2(dy, dx) * (180 / Math.PI);

    // Normalizar el ángulo entre 0 y 360
    const normalizedCurrentAngle = (currentAngle + 360) % 360;
    const normalizedPreviousAngle = (previousAngle.current + 360) % 360;

    // Calcular la diferencia de ángulo
    let angleDifference = normalizedCurrentAngle - normalizedPreviousAngle;
    if (angleDifference < -180) angleDifference += 360;
    if (angleDifference > 180) angleDifference -= 360;

    // Acumular el ángulo absoluto del movimiento
    accumulatedAngle.current += Math.abs(angleDifference);

    // Detectar si se ha acumulado al menos 180° y cruzado el rango de 170° a 180°
    if (
      accumulatedAngle.current >= 180 &&
      normalizedPreviousAngle > 170 &&
      normalizedCurrentAngle < 180 &&
      !hasTriggered.current
    ) {
      hasTriggered.current = true; // Marcar que ya se disparó el evento
      setFullTurns((prev) => prev + 1); // Incrementar vueltas completas
    }

    // Vibrar mientras se gira
    startVibration();

    // Resetear la bandera cuando el ángulo sale del rango
    if (normalizedCurrentAngle > 180 && normalizedCurrentAngle < 170) {
      hasTriggered.current = false; // Permitir que se dispare de nuevo
    }

    previousAngle.current = currentAngle; // Actualizar el ángulo anterior
    setAngle(currentAngle); // Actualizar el estado del ángulo
  };

  const handlePointerUp = () => {
    stopVibration(); // Detener la vibración cuando el puntero se levante
    centerRef.current = { x: 0, y: 0 }; // Reiniciar el centro
  };

  const [showFlash, setShowFlash] = useState(false);

  const [itemRecievedFX] = useSound(ITEMRECIEVEDMP3, { volume: 0.2 });
  useEffect(() => {
    if (fullTurns && pokeChoose) {
      stopSong();
      itemRecievedFX()
      setTimeout(() => {
        setShowFlash(true)
      }, 1000); // Activa el brillo después del fade-in
    } else if(fullTurns) {

    }
  }, [fullTurns, pokeChoose]);

  const [scale, setScale] = useState(1);
  const [translateY, setTranslateY] = useState(-5);
  const [prevAngle, setPrevAngle] = useState(angle);
  const [timeoutId, setTimeoutId] = useState(null);

  useEffect(() => {
    if (angle !== prevAngle) {
      setScale(scale < 1.4 ? scale+0.005 : 1.4); // Aplica un pequeño zoom
      setTranslateY(-15); // Desplazar más arriba
      setPrevAngle(angle);

      // Limpiar timeout anterior
      if (timeoutId) clearTimeout(timeoutId);

      // Volver al estado original después de 1s sin cambios
      const newTimeoutId = setTimeout(() => {
        setScale(1);
        setTranslateY(-5); // Volver a la posición original
      }, 1300);
      setTimeoutId(newTimeoutId);
    }
  }, [angle, prevAngle, timeoutId]);

  const [preChoise, setPreChoise] = useState(null);

  
  const { mutateAsync } = useConfirmarSeleccion();
  const navigate = useNavigate();
  const handleClick = (pokeChoose) => {

    if (POKEEJEMPLOSCOIN.length == 1) {
      navigate(`/pokedex/detalle?n_pokedex=${pokeChoose.numeroDex}`)
    } else {
      mutateAsync({
        idPokemon: pokeChoose.idPokemon,
        keyCache: keyCache
      }).then(response => {
        navigate(`/pokedex/detalle?n_pokedex=${pokeChoose.numeroDex}`)
      });

    }
  }
  return (
    <Container scale={scale} translateY={translateY}>
        <Engranaje src={imagenesCache[3]}
          angle={angle*2}
        />
        <Gashapon src={imagenesCache[1]}/>
        {children}
        {
          fullTurns ? 
          <Manilla src={imagenesCache[2]}/> : 
          <Manilla src={imagenesCache[2]}
            angle={angle}
            onPointerDown={handlePointerDown}
            onPointerMove={handlePointerMove}
            onPointerUp={handlePointerUp}
          />
        }
        {
          fullTurns && scale != 1 ? <GashaBall src={imagenesCache[4]}/> : null
        }
        {
          angle == 0 && <Notify><p>GIRA LA MANILLA</p></Notify>
        }
        {
          fullTurns && !showFlash && !pokeChoose && scale == 1 ?
            <PrizeContainer>
              <Notify><p>SELECCIONA TU PREMIO</p></Notify>
              {
                POKEEJEMPLOSCOIN.length == 2 && <>
                  <CapsulaChoosen pokemon={POKEEJEMPLOSCOIN[0]} translate="-15vw, -10vh" setPreChoise={setPreChoise} preChoise={preChoise}/>
                  <CapsulaChoosen pokemon={POKEEJEMPLOSCOIN[1]} translate="15vw, 10vh" setPreChoise={setPreChoise} preChoise={preChoise}/>
                </>
              }
              {
                POKEEJEMPLOSCOIN.length == 3 && <>
                  <CapsulaChoosen pokemon={POKEEJEMPLOSCOIN[0]} translate="0, 10vh" setPreChoise={setPreChoise} preChoise={preChoise}/>
                  <CapsulaChoosen pokemon={POKEEJEMPLOSCOIN[1]} translate="-25vw, -10vh" setPreChoise={setPreChoise} preChoise={preChoise}/>
                  <CapsulaChoosen pokemon={POKEEJEMPLOSCOIN[2]} translate="25vw, -10vh" setPreChoise={setPreChoise} preChoise={preChoise}/>
                </>
              }
              <ButtonSelect onClick={() => setChoose(preChoise)}><p>SELECCIONAR</p></ButtonSelect>
            </PrizeContainer> : null
        }
        {
          showFlash && pokeChoose ? <PrizeContainer>
            <div style={{position: 'absolute',width:'100vw', height: '50vh'}}>
              <Sparkle
                color={'random'}
                count={100}
                minSize={15}
                maxSize={28}
                overflowPx={40}
                fadeOutSpeed={50}
                newSparkleOnFadeOut={true}
                flicker={true}
                flickerSpeed='slowest'
              />
            </div>
            <GashaBallOpen src={imagenesCache[5]}/>
            <PokeImg src={POKEIMAGENESURL.replaceAll('NOMBREPOKEMON',pokeChoose.nombre)} />
              <ButtonSelect color='red' onClick={() => handleClick(pokeChoose)}><p style={{color: 'white'}}>ACEPTAR</p></ButtonSelect>
          </PrizeContainer> : null
        }
    </Container>
  );
};